import datastore from './datastore'
export default {
  get({ values }) {
    if (values.branchId === 1) {
      return [200, { data: datastore[values.branchId - 1] }]
    }
    return [501, {}]
  },
}
